import { Apollo } from 'apollo-angular';
import { HttpClient } from '@angular/common/http';
import { environment } from '@prcins/environments';
import { map } from 'rxjs/operators';
import { BillingInstallmentsQuery, HomeEndorsementControlAgentQuery } from '@prcins/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "apollo-angular";
var OpenmortgageamendmentService = /** @class */ (function () {
    // apiUrl = "http://apis.dev.prcaws.net/eservice-ws/v2/";
    function OpenmortgageamendmentService(http, apollo) {
        this.http = http;
        this.apollo = apollo;
        this.apiUrl = environment.BASE_URL + "/v2/";
    }
    OpenmortgageamendmentService.prototype.getInstallmentDetails = function () {
        var policyNumber = sessionStorage.getItem('currentPolicy');
        return this.apollo
            .watchQuery({
            query: BillingInstallmentsQuery,
            variables: {
                policyNumber: policyNumber
            }
        })
            .valueChanges.pipe(map(function (_a) {
            var data = _a.data;
            return data;
        }));
    };
    OpenmortgageamendmentService.prototype.getInstallmentDetailsFromCache = function (policyNumber) {
        return this.apollo
            .getClient()
            .readQuery({
            query: BillingInstallmentsQuery,
            variables: {
                policyNumber: policyNumber
            }
        });
    };
    OpenmortgageamendmentService.prototype.updateInstallmentDetailsFromCache = function (policyNumber, payload) {
        return this.apollo
            .getClient()
            .writeQuery({
            query: BillingInstallmentsQuery,
            variables: {
                policyNumber: policyNumber
            },
            data: payload
        });
    };
    OpenmortgageamendmentService.prototype.getAdrControlAgent = function (policyNumber) {
        return this.apollo
            .watchQuery({
            query: HomeEndorsementControlAgentQuery,
            variables: {
                policyNumber: policyNumber
            }
        })
            .valueChanges.pipe(map(function (_a) {
            var data = _a.data;
            return data;
        }));
    };
    OpenmortgageamendmentService.prototype.recordEndorsmentBlocked = function (type, guid) {
        var policyNum = sessionStorage.getItem('currentPolicy');
        return this.http.put(this.apiUrl + 'core/' + policyNum + '/endorsements/recordEndorsmentBlocked?type=' + type + (guid ? '&guid=' + guid : ''), {});
    };
    OpenmortgageamendmentService.prototype.createEndorsement = function (type) {
        var policyNum = sessionStorage.getItem('currentPolicy');
        return this.http.post(this.apiUrl + policyNum + '/endorsements?type=' + type, {});
    };
    OpenmortgageamendmentService.prototype.getEndorsementSummary = function (policyNum, guid) {
        return this.http.get(this.apiUrl + policyNum + '/endorsements/' + guid);
    };
    OpenmortgageamendmentService.prototype.rateEndorsement = function () {
        var policyNum = sessionStorage.getItem('currentPolicy');
        var guid = sessionStorage.getItem('guid');
        return this.http.put(this.apiUrl + policyNum + '/endorsements/' + guid + '/rate', {});
    };
    OpenmortgageamendmentService.prototype.issueEndorsePolicyV2 = function (policyNum, guid, request) {
        return this.http.put(this.apiUrl + policyNum + '/endorsements/' + guid + '/issue', request)
            .pipe(map(function (response) {
            var error = response.error, payplanLabel = response.billingEndorsements[0].endorsementEntity.endorsementBillingDetails.payplanLabel, fileId = response.summary.metaInfo.fileId;
            return { errorCode: error, fileId: fileId, payplanLabel: payplanLabel };
        }));
    };
    OpenmortgageamendmentService.prototype.cancelEndorsement = function () {
        var policyNum = sessionStorage.getItem('currentPolicy') ? sessionStorage.getItem('currentPolicy') : sessionStorage.getItem('splPolicyNumber');
        var guid = sessionStorage.getItem('guid') ? sessionStorage.getItem('guid') : sessionStorage.getItem('splGuid');
        var url = this.apiUrl + policyNum + '/endorsements/' + guid;
        return this.http.delete(url);
    };
    OpenmortgageamendmentService.prototype.cancelEndorsementWithParams = function (policyNum, guid) {
        var url = this.apiUrl + policyNum + '/endorsements/' + guid;
        return this.http.delete(url);
    };
    OpenmortgageamendmentService.prototype.deleteMortgageeEndorsement = function (mortgageeId) {
        var policyNum = sessionStorage.getItem('currentPolicy');
        var guid = sessionStorage.getItem('guid');
        var url = this.apiUrl + policyNum + '/endorsements/' + guid + '/mortgagees/' + mortgageeId;
        return this.http.delete(url);
    };
    OpenmortgageamendmentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OpenmortgageamendmentService_Factory() { return new OpenmortgageamendmentService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Apollo)); }, token: OpenmortgageamendmentService, providedIn: "root" });
    return OpenmortgageamendmentService;
}());
export { OpenmortgageamendmentService };
